import { useQuery } from 'react-query';

import { CardFlags } from '../../types/card-flags.enum';
import { api } from '../api';

export interface IEstablishment {
  id: number;
  fantasia: string;
  tipoPessoa: string;
  razao: string;
  docto: string;
  permiteAntecipacao: "S" | "N";
  modoCalcTxAntec: number;
  ptTxAntecipacao: number;
  servicoPedidoAntecipacao: IServicoPedidoAntecipacao;
}

export interface IServicoPedidoAntecipacao {
  status: number;
  descricao: string;
}

interface IEstablishmentParams {
  docto: string;
}

export async function getEstabelecimento(
  params: IEstablishmentParams
): Promise<IEstablishment> {
  const { data } = await api.get('establishment/estabelecimento', {
    params,
  });

  return data;
}

export function useEstabelecimento(params: IEstablishmentParams) {
  return useQuery(
    ['estabelecimento', params.docto],
    () => getEstabelecimento(params),
    {
      staleTime: Infinity,
      enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto,
      retry: 2
    }
  );
}
